const regx = {
  phone: /^(?:[^\d]*\d){10}[^\d]*$/,
};

export default regx;
